module.exports = "/images/sidebar-1.jpg?23832d313db62da22b084cd4429ca606";